import { gql } from '@apollo/client';

export default gql`
  mutation createInspection(
    $name: String!
    $placeId: ID!
    $inspectionSubjectId: ID
    $periodCycle: String!
    $periodNumber: Int!
    $dueDate: ISO8601DateTime
    $notes: String
    $templateId: ID
    $inspectionFields: [InspectionFieldInput!]
    $inspectorId: ID
  ) {
    createInspection(
      input: {
        name: $name
        placeId: $placeId
        inspectionSubjectId: $inspectionSubjectId
        periodCycle: $periodCycle
        periodNumber: $periodNumber
        dueDate: $dueDate
        notes: $notes
        templateId: $templateId
        inspectionFields: $inspectionFields
        inspectorId: $inspectorId
      }
    ) {
      inspection {
        id
        name
        inspectionSubject {
          id
        }
        place {
          id
        }
      }
    }
  }
`;
